import { Mail } from "lucide-react";
import { motion } from "framer-motion";
import { TEAM } from "../data/landing";
import { Reveal } from "../components/Reveal";

const ABOUT_EASE = [0.22, 1, 0.36, 1];

export default function About() {
  return (
    <section
      id="about"
      className="relative bg-[#050B26] py-24 sm:py-32 border-t border-white/5"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <Reveal className="lg:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#1440E1] font-semibold mb-4">
              About Us
            </p>
            <h2 className="font-arial-black text-4xl sm:text-5xl lg:text-6xl text-white leading-tight tracking-tight">
              The team behind the moves.
            </h2>
          </Reveal>
          <Reveal delay={0.12} className="lg:col-span-7 lg:pt-4">
            <p className="text-white/70 text-base sm:text-lg leading-relaxed">
              We&rsquo;re a tight-knit team of strategists, creatives, and
              operators based in Cincinnati. We obsess over the details so our
              clients can obsess over their customers — partnering with brands
              who refuse to blend in.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {TEAM.map((m, i) => (
            <motion.article
              key={m.name}
              className="team-card group relative overflow-hidden"
              data-testid={`team-card-${i}`}
              initial={{ opacity: 0, y: 34 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: ABOUT_EASE }}
            >
              <div className="aspect-[4/5] overflow-hidden bg-black relative">
                <img
                  src={m.photo}
                  alt={m.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-all duration-700 ease-out"
                  data-testid={`team-photo-${i}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1a4a]/85 via-[#0a1a4a]/15 to-transparent opacity-90 group-hover:opacity-70 transition-opacity duration-500" />
                <div className="absolute inset-0 ring-0 group-hover:ring-2 ring-[#1440E1] ring-inset transition-all duration-500" />
              </div>
              <div className="relative p-6 sm:p-7 bg-gradient-to-br from-[#1440E1] to-[#0b1f6e] group-hover:from-[#1a52ff] group-hover:to-[#0d28a7] transition-all duration-500">
                <p className="text-[11px] uppercase tracking-[0.25em] text-white/80 font-semibold mb-2">
                  {m.role}
                </p>
                <h3 className="font-display text-2xl font-bold text-white mb-3 tracking-tight">
                  {m.name}
                </h3>
                <p className="text-sm text-white/85 leading-relaxed">
                  {m.desc}
                </p>
                {m.email ? (
                  <a
                    href={`mailto:${m.email}`}
                    className="mt-4 inline-flex items-center gap-2 text-xs sm:text-sm font-medium text-white/95 hover:text-white border-b border-white/40 hover:border-white pb-0.5 transition-colors break-all"
                    data-testid={`team-email-${i}`}
                  >
                    <Mail size={14} />
                    {m.email}
                  </a>
                ) : null}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
